import FormUISlider from 'root/main/components/forms/ui/formUISlider';

const FormUISliderInit = els => {
    const formEls = els;
    if (formEls.length > 0) {
        formEls.forEach(formEl => {
            if (formEl) {
                const formUISlider = new FormUISlider(formEl);
                formUISlider.loadFormSpecs();
            }
        });
    }
};

export { FormUISliderInit as default };
